import { render, staticRenderFns } from "./RankingTable.vue?vue&type=template&id=02b40446&scoped=true"
import script from "./RankingTable.vue?vue&type=script&lang=js"
export * from "./RankingTable.vue?vue&type=script&lang=js"
import style0 from "./RankingTable.vue?vue&type=style&index=0&id=02b40446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b40446",
  null
  
)

export default component.exports